export default __webpack_public_path__ + "static/media/Head_5_Ear_1_C3.e42b8309.svg";